






































































































































































































































































import Vue from "vue";
import Partnerships from "@/views/mobile/Partnerships.vue";
import Text from "@/components/mobile/Text.vue";
import Space from "@/components/mobile/Space.vue";
import Button from "@/components/mobile/Button.vue";
export default Vue.extend({
  name: "Home",
  data() {
    return {
      name: "abc",
      gridList: [
        {
          title: "GLOBAL LIQUIDITY",
          subTitle:
            "By connecting to all major liquidity <br /> providers in the world,we offer excellent <br /> liquidity and competitive quotes.",
          imgPath: require("@/assets/img/home/worldliquidity-icon.svg"),
          altText: "worldliquidity-icon"
        },
        {
          title: "FAST SETTLEMENT",
          subTitle:
            "Same-day Crypto-Fiat settlements for the <br /> U.S. and Next-day for EU/Asia. Nearly instant <br /> settlements for Crypto-Crypto trades.",
          imgPath: require("@/assets/img/home/settlement-icon.svg"),
          altText: "settlement-icon"
        },
        {
          title: "TRADING EXPRERTISE",
          subTitle:
            "Our experienced trading team meets and <br /> exceeds the needs of each client. Electronic <br /> OTC APIs are available for institutions.",
          imgPath: require("@/assets/img/home/pro-icon.svg"),
          altText: "pro-icon"
        },
        {
          title: "BEST SUPPORT",
          subTitle:
            "Thank you for choosing Legend Trading. We <br /> promise an efficient customer on-boarding <br /> process and responsive customer support.",
          imgPath: require("@/assets/img/home/support-icon.svg"),
          altText: "support-icon"
        }
      ],
      numberList: [
        {
          title: "$1B+",
          subTitle: "BANK TRANSFERS AND <br /> SETTLEMENTS PER MONTH"
        },
        {
          title: "800+",
          subTitle: "INSTITUTIONAL CLIENTS"
        },
        {
          title: "150+",
          subTitle: "COUNTRIES"
        }
      ]
    };
  },
  components: {
    Partnerships,
    MobileText: Text,
    MobileSpace: Space,
    MobileButton: Button
  }
});
